import { Component, OnInit } from '@angular/core';
import { DevUtilService } from 'src/app/services/dev-util.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-dev-utils-widget',
  templateUrl: './dev-utils-widget.component.html',
  styleUrls: ['./dev-utils-widget.component.less']
})
export class DevUtilsWidgetComponent implements OnInit{
  constructor(public devs: DevUtilService, public toast : ToastrService){}
  ngOnInit(): void {
    this.audioChime.load();
  }
  spsId : number;
  audioChime = new Audio('/assets/cashMeOutside.mp3');
  plachCash(){
    this.audioChime.play();
  }

  dropSeed(){
    if(this.spsId){
      this.devs.dropSearchSeed(this.spsId).subscribe(()=>{
        this.toast.success('Seed Dropped');
      });
    }

  }
}
